import GalleryPreview from './GalleryPreview';
export default GalleryPreview;
